export const mergeRefreshedTaxonomyRoots = (freshRoots = [], currentRoots = []) => {
    const currentById = new Map(currentRoots.map(node => [node.id, node]));

    return freshRoots.map(freshNode => {
        const currentNode = currentById.get(freshNode.id);
        if (!currentNode) return freshNode;

        const children = freshNode.has_children === false ? [] : (
            Object.prototype.hasOwnProperty.call(freshNode, 'children') ?
                mergeRefreshedTaxonomyRoots(freshNode.children || [], currentNode.children || []) :
                currentNode.children
        );

        return {
            ...currentNode,
            ...freshNode,
            ...(children && {children}),
        };
    });
};

export const loadedTaxonomyParentIds = (nodes = []) => {
    const ids = [];
    const visit = currentNodes => currentNodes.forEach(node => {
        if (!node.has_children || !Object.prototype.hasOwnProperty.call(node, 'children')) return;

        ids.push(node.id);
        visit(node.children || []);
    });

    visit(nodes);
    return ids;
};

export const applyRefreshedTaxonomyBranches = (nodes, branches) => {
    const childrenByParentId = new Map(branches.map(({parentId, children}) => [parentId, children]));
    const visit = currentNodes => currentNodes.map(node => {
        const children = childrenByParentId.has(node.id) ? childrenByParentId.get(node.id) : node.children;
        return {
            ...node,
            ...(children && {children: visit(children)}),
        };
    });

    return visit(nodes);
};
